
const verifyfour = (column, player) => {

    let numberinline=0;
    for(let i=0; i<column.length; i++){
        if(column[i]===player) {
            numberinline++;
            if(numberinline>=4) return true;
        }
        else {
            numberinline=0;
        }
    }


    return false
}

const getrow= (gameboard, lastmove)=>{
    
    let rownumber = getrownumberlastmove(gameboard, lastmove);

    let row = gameboard.map((column)=>{ return column[rownumber-1] });

    return row;

}

export const getrownumberlastmove = (gameboard, lastmove) =>{
    let column = gameboard[lastmove-1];
    let rownumber = column.reduce((k, e)=> {
            if(e!==0) return k+1
            else return k
        }, 0);

    return rownumber;
}

const getinicialleftpoint = (rownumber, columnumber)=>{
    let columnpostion = (columnumber - rownumber) >= 0 ? (columnumber-rownumber) : 0;
    let rowposition =  (rownumber - columnumber) < 0 ? 0  : (rownumber - columnumber);

    return [columnpostion, rowposition];
}

const getinicialrigthpoint = (rownumber, columnumber)=>{
    let columnpostion = (columnumber+rownumber-2) < 7 ? (columnumber+rownumber-2): 6;
    let rowposition = (columnumber+rownumber) > 7 ? (columnumber+rownumber-8) : 0;

    return [columnpostion, rowposition];
}

const getleftdiagonal = (gameboard, columnpostion, rowposition) => {

    let column = columnpostion;
    let row = rowposition;

    let length = 0;
    let diagonal = [];

    while(column<7 && row<6){
        diagonal[length] = gameboard[column][row];
        column++;
        row++
        length++
    }

    return diagonal;

}

const getrigthdiagonal = (gameboard, columnpostion, rowposition) => {

    let column = columnpostion;
    let row = rowposition;

    let length = 0;
    let diagonal = [];

    while(column>=0 && row<6){
        diagonal[length] = gameboard[column][row];
        column--;
        row++
        length++
    }

    return diagonal;

}

export const checkFinish = (game, lastMove, player)=>{
    let rownumber = getrownumberlastmove(game, lastMove);
    let leftpoint = getinicialleftpoint(rownumber, lastMove);
    let leftdiagonal = getleftdiagonal(game, leftpoint[0], leftpoint[1]);

    let rigthpoint = getinicialrigthpoint(rownumber, lastMove);
    let rigthdiagonal = getrigthdiagonal(game, rigthpoint[0], rigthpoint[1]);
    if(verifyfour(leftdiagonal, player) ||
        verifyfour(rigthdiagonal, player) || 
        verifyfour(getrow(game, lastMove), player) ||
        verifyfour(game[lastMove-1], player)){
            return true;
        }

    return false;

}

export const getPosibleMoves = (gameboard) => {
    let valid = [1, 1, 1, 1, 1, 1, 1];

    for(let i=0; i<=6; i++){
        if(gameboard[i][5]!==0) valid[i]=0;
    }
    return valid;
}